import { combineReducers, legacy_createStore } from "redux";
import { reducer as LoginReducer } from "./reducer";
let rootReducer = combineReducers({
  LoginReducer,
});
export let store = legacy_createStore(rootReducer);
